export enum CarnivoreDamageInspectedBy {
    Sno = 1,
    Sysselmester = 2,
    Lansstyrelsen = 3,
    SamiVillage = 4,
    NotControlledInField = 5
}
